const validate = values => {
	const errors = {}
	if (!values.guarantor_type) {
		errors.guarantor_type = 'Este Campo es Obligatorio'
	}
	return errors
}
	
export default validate
  


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsGuarantorForm.js
 **/